export class Generator {
  constructor() {
    this.context = new AudioContext()
    this.stack = []
  }

  tone(frequency, type, duration) {
    const g = this.context.createGain()

    const o = this.context.createOscillator()
    o.type = type
    o.connect(g)
    o.frequency.value = frequency
    o.start(0)
    g.connect(this.context.destination)
    this.stack.push(o)

    g.gain.exponentialRampToValueAtTime(
      0.00001,
      this.context.currentTime + duration
    )

    const t = setTimeout(() => {
      const index = this.stack.indexOf(o)
      if (index !== -1) {
        this.stack.splice(index, 1)
      }
    }, duration + 1)
  }
}
